export default __webpack_public_path__ + "static/src/assets/images/icons/bottom_icon_hk.png";